// extracted by mini-css-extract-plugin
export default {"select":"JxuyoDJ19jcdftbKden3"};